import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService, CommonService, CommonAPIService } from '../../../services';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApplyCourseComponent } from '../home/apply-course/apply-course.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-courses',
  standalone: false,
  templateUrl: './courses.component.html',
  styleUrl: './courses.component.scss'
})
export class CoursesComponent {
  modalOpen: NgbModalRef | undefined;
  currentTab = 'tab1';
  coursesData: any = {};
  coursesSubCategoryId: any;
  isOpen = false;
  safeDescription!: any;
  imageUrl: string = environment.imageURL;
  safeYoutubeUrl!: SafeResourceUrl;
  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    let getCourseData = this.commonAPIService.data;
    if (getCourseData) {
      this.coursesSubCategoryId = getCourseData.coursesSubCategoryId;
      this.getCourses();
    }
    if (!getCourseData) {
      const storedData = localStorage.getItem('serviceData');
      if (storedData) {
        getCourseData = JSON.parse(storedData);
        this.coursesSubCategoryId = getCourseData.coursesSubCategoryId;
        this.getCourses();
      }
    }
  }
  switchTab(event: MouseEvent, tab: string) {
    event.preventDefault();
    this.currentTab = tab;
  }

  openPopup(youtubeLink: string) {
    const videoId = this.extractYoutubeId(youtubeLink);
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    this.safeYoutubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    this.isOpen = true;
  }

  extractYoutubeId(url: string): string {
    // works for shorts, watch, youtu.be
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : '';
  }

  closePopup(): void {
    this.isOpen = false;
  }

  applyForAdmission() {
    const modalRef = this.modalService.open(ApplyCourseComponent, { centered: true, modalDialogClass: 'apply-course', backdropClass: 'delete-backdrop', size: 'lg' });
    modalRef.componentInstance.course = this.coursesData[0];
  }

  async getCourses() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getCourses', false);
      const response: any = await this.commonAPIService.getCall('getCourses', this.coursesSubCategoryId);
      this.commonService.resetAPIFlag('getCourses', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.coursesData = response?.data;
            const rawHtml = this.coursesData[0].coursesDescription;
            const cleanedHtml = rawHtml.replace(/&nbsp;/g, ' ');
            this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);
            this.sharedService.setApiCall(false);
          }
          else {
            this.coursesData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.coursesData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting Courses details:', error);
    }
  }
}
